import { Router, NavigationEnd } from "@angular/router";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class CookieConsentService implements CanActivate {

    constructor(private cookieService: CookieService, private router: Router) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        this.checkCookieConsent();
        return true;
    }

    checkCookieConsent() {
        const catalogries = this.getCookieConsent();
        const allCookie = this.cookieService.getAll();
        // console.log(allCookie)
        const consentResult = []
        for (let i = 1; i < catalogries.length; i++) {
            const c = catalogries[i].split(':');
            consentResult.push(c[1]);
            this.manageCookie(c, allCookie);
        }
        return consentResult;
    }

    checkGoogleTag() {
        const catalogries = this.getCookieConsent();
        for (let i = 1; i < catalogries.length; i++) {
            const c = catalogries[i].split(':');
            if (c[0] === 'C0004') {
                return c[1];
            }
        }
        return '0';
    }

    private getCookieConsent() {
        const consent = this.cookieService.get('OptanonConsent');
        if (consent === '') {
            return [];
        }
        const cookie: string[] = consent.split('&');
        for (const g in cookie) {
            if (cookie[g].match('groups')) {
                const catalogries = cookie[g].split(',');
                return catalogries;
            }
        }
        return [];
    }

    private manageCookie(c: string[], allCookie: object) {
        // if c === '0' then not consent // need to delete cookie
        // i == 2 = Performance Cookies (_gat_UA-, _gid, _ga)
        // i == 3 = Functional Cookies (__cfduid)
        // i == 4 = Targeting Cookies (_fbp, fr, _gat_gtag_xxxxxxxxxxxxxxxxxxxxxxxxxxx)
        // i == 5 = Social Media Cookies ()
        for (const o in allCookie) {
            if (allCookie.hasOwnProperty(o)) {
                console.log(o);
                if (c[0] === 'C0002' && c[1] === '0') {
                    if (o.match(/_gat_UA/) || o === '_gid' || o === '_ga') {
                        this.cookieService.delete(o);
                        this.cookieService.delete(o, '/', '.one-asset.com');
                    }
                } else if (c[0] === 'C0003' && c[1] === '0') {
                    if (o === '__cfduid') {
                        this.cookieService.delete(o);
                        this.cookieService.delete(o, '/', '.one-asset.com');
                    }
                } else if (c[0] === 'C0004' && c[1] === '0') {
                    if (o.match(/_gat_gtag/) || o === '_fbp' || o === 'fr') {
                        this.cookieService.delete(o);
                        this.cookieService.delete(o, '/', '.one-asset.com');
                    }
                }
            }
        }
    }
}
